import { action } from 'satcheljs';

export const updateInboxTabsWatermarks = action(
    'UPDATE_INBOX_TABS_WATERMARKS',
    (watermarksToWrite: string[]) => ({
        watermarksToWrite,
    })
);
